module.exports = __webpack_public_path__ + "static/media/boomer-avatar-background.e5677966.png";